module.exports = __webpack_public_path__ + "img/sj1.854ee8e5.png";